import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { Box, Button, Toolbar, Typography, useTheme } from "@mui/material";
import {
	DeleteButton,
	ResetButton,
	SubmitButton,
} from "@websential/cosmic-v20";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardSharpIcon from "@mui/icons-material/ArrowDownwardSharp";
import { grey } from "@mui/material/colors";

export interface ITD1AdminFormToolbar {
	openNew: () => void;
	// confirmDeleteSelected: () => void;
	// onMoveUpClickHandler: () => void;
	// onMoveDownClickHandler: () => void;
	// selectedDepartments: any;
}

export const TD1AdminFormToolbar: FC<ITD1AdminFormToolbar> = ({
	openNew,
	// confirmDeleteSelected,
	// onMoveUpClickHandler,
	// onMoveDownClickHandler,
	// selectedDepartments,
}) => {
	const theme = useTheme();
	return (
		<Box
			// position="sticky"
			// color="default"
			// elevation={1}
			sx={
				{
					// backgroundColor: "#fff",
					// borderRadius: "5px",
					// marginBottom: theme.spacing(4),
					// boxShadow:
					// 	"-1px -1px 3px -3px rgba(0,0,0,0.2),0px 0px 4px 2px rgba(0,0,0,0.14),0px 1px 0px -2px rgba(0,0,0,0.12)",
					// top: theme.mixins.toolbar.minHeight
				}
			}
		>
			<Toolbar sx={{ justifyContent: "end", paddingRight: "0!important" }}>
				<>
					<Button
						size="medium"
						startIcon={<AddIcon />}
						variant="contained"
						sx={{
							backgroundColor: theme.palette.primary.main,
							color: theme.palette.common.white,
							"&:hover": {
								backgroundColor: theme.palette.primary.dark,
							},
							textTransform: "none",
						}}
						onClick={openNew}
					>
						<Typography>Add</Typography>
					</Button>
					{/* <Button
						size="medium"
						startIcon={<DeleteOutlineIcon />}
						variant="outlined"
						color="error"
						onClick={confirmDeleteSelected}
						sx={{
							marginLeft: 2,
						}}
						disabled={!selectedDepartments || !selectedDepartments.length}
					>
						<Typography sx={{ textTransform: "none" }}>Delete</Typography>
					</Button>

					<Button
						size="medium"
						startIcon={<ArrowUpwardIcon />}
						variant="contained"
						onClick={onMoveUpClickHandler}
						sx={{
							marginLeft: 2,
							backgroundColor: grey[300],
							"&:hover": {
								backgroundColor: grey[400],
							},
							color: grey[900],
						}}
						disabled={!selectedDepartments || !selectedDepartments.length}
					>
						<Typography sx={{ textTransform: "none" }}>Move Up</Typography>
					</Button>
					<Button
						size="medium"
						startIcon={<ArrowDownwardSharpIcon />}
						variant="contained"
						onClick={onMoveDownClickHandler}
						sx={{
							marginLeft: 2,
							backgroundColor: grey[300],
							"&:hover": {
								backgroundColor: grey[400],
							},
							color: grey[900],
						}}
						disabled={!selectedDepartments || !selectedDepartments.length}
						// disabled={selectedDepartments.length !== 1}
					>
						<Typography sx={{ textTransform: "none" }}>Move Down</Typography>
					</Button> */}
				</>
			</Toolbar>
		</Box>
	);
};
